module.exports = __webpack_public_path__ + "img/On Reservation.2e99ba7a.jpeg";